import React from 'react';

import {
  AccountCircle,
  CardTravel,
  DashboardOutlined,
  DragHandle,
  Group,
  RecordVoiceOver,
  SettingsApplicationsRounded,
  ShoppingCart,
  Receipt,
} from '@material-ui/icons';
import { ROLADMIN, ROLCOLABORADOR, ROLREVENDEDOR, ROLVENDEDOR } from '../utils/constants';

export const menuItems = [
  {
    name: 'Dashboard',
    route: '/',
    role: [ROLADMIN, ROLCOLABORADOR, ROLREVENDEDOR, ROLVENDEDOR],
    icon: <DashboardOutlined />,
  },
  {
    name: 'Usuarios',
    route: '/users',
    role: [ROLADMIN],
    icon: <AccountCircle />,
  },
  {
    name: 'Proveedores',
    route: '/suppliers',
    role: [ROLADMIN, ROLCOLABORADOR],
    icon: <RecordVoiceOver />,
  },
  {
    name: 'Servicios',
    route: '/services',
    role: [ROLADMIN, ROLVENDEDOR],
    icon: <CardTravel />,
  },
  {
    name: 'Clientes',
    route: '/clients',
    role: [ROLADMIN],
    icon: <Group />,
  },
  {
    name: 'Comisionistas',
    route: '/comisionistas',
    role: [ROLADMIN],
    icon: <Group />,
  },
  {
    name: 'Reservas',
    route: '/sales',
    role: [ROLADMIN, ROLVENDEDOR, ROLREVENDEDOR],
    icon: <ShoppingCart />,
  },
  {
    name: 'Facturas',
    route: '/receipts',
    role: [ROLADMIN],
    icon: <Receipt />,
  },
  {
    name: 'Líneas',
    route: '/lines',
    role: [ROLADMIN, ROLVENDEDOR, ROLCOLABORADOR],
    icon: <DragHandle />,
  },
  /*{
        name: 'Tipos Cambio',
        route: '/exchanges',
        role: [ROLADMIN],
        icon: <MonetizationOnOutlined /> 

    },*/
  {
    name: 'Ajustes',
    route: '/settings',
    role: [ROLADMIN],
    icon: <SettingsApplicationsRounded />,
  },
];
